import ProfileService from '@/core/services/profile.service';

// action types
export const ADD_MAILBOX_CHANGE_INCREMENT = 'addMailboxChangeIncrement';
export const RESET_USER_DATA = 'resetUserData';
export const VERIFY_USER_DATA = 'verifyUserData';

// mutation types
export const SET_ANONYMOUS_VISIT = 'setAnonymousVisit';
export const SET_USER_DATA = 'setUserData';
export const SET_USER_ROLES = 'setUserRoles';
export const SET_USER_MENU = 'setUserMenu';
export const SET_USER_AVATAR = 'setUserAvatar';
export const SET_CURRENT_SUBSCRIPTION = 'setCurrentSubscription';
export const SET_WAITING_SUBSCRIPTION = 'setWaitingSubscription';
export const SET_COOKIE_CONSENT_CATEGORIES = 'setCookieConsentCategories';
export const SET_ACL = 'setAcl';
export const SET_MAILBOX_CHANGE_INCREMENT = 'setMailboxChange';

const state = {
  anonymousVisit: true,
  currentSubscription: null,
  waitingSubscription: null,
  userRoles: null,
  userData: null,
  userMenu: '',
  userAvatar: '',
  cookieConsentCategories: [],
  enabledFeatures: [],
  acl: [],
  mailboxChangeIncrement: 0,
};

const getters = {
  userInfo(_state) {
    return _state.userData;
  },

  currentSubscription(_state) {
    return _state.currentSubscription;
  },

  waitingSubscription(_state) {
    return _state.waitingSubscription;
  },

  isAnonymousVisit(_state) {
    return _state.anonymousVisit;
  },

  isAdmin(_state) {
    return _state.acl
      && _state.acl.admin === 1;
  },

  isPoiEditor(_state) {
    return _state.acl
      && _state.acl.frontendEditor
      && _state.acl.frontendEditor.poi === 1;
  },

  isServiceProvider(_state) {
    return _state.userRoles
      && _state.userRoles.PROVIDER != undefined
      && _state.userRoles.PROVIDER === true;
  },

  isServiceConsumer(_state) {
    return _state.userRoles
      && _state.userRoles.CONSUMER != undefined
      && _state.userRoles.CONSUMER === true;
  },
};

const actions = {
  [ADD_MAILBOX_CHANGE_INCREMENT](context, incrementValue) {
    const newValue = context.state.mailboxChangeIncrement + incrementValue;
    context.commit(SET_MAILBOX_CHANGE_INCREMENT, newValue);
  },
  [VERIFY_USER_DATA](context) {
    return new Promise((resolve, reject) => {
      const userData = ProfileService.getUserData();
      if (!userData) {
        // we do not have user data stored in profile store
        // so we try to fetch fresh user data.
        // If it won't be successful, we will kill the app authentication state
        // to avoid unpredictable behaviour of the app !! better so, than dealing with edge cases
        // all the time and partial app functionality
        ProfileService.initUserData()
            .done(( data ) => {
              resolve(data);
            })
            .fail(( response ) => {
              context.commit(PURGE_AUTH);
              resolve(false);
            });
      } else resolve(userData);
    });
  },
  [RESET_USER_DATA](context) {
    context.commit(SET_USER_DATA, null);
    context.commit(SET_USER_ROLES, null);
    context.commit(SET_USER_MENU, '');
    context.commit(SET_USER_AVATAR, '');
    context.commit(SET_CURRENT_SUBSCRIPTION, null);
    context.commit(SET_WAITING_SUBSCRIPTION, null);
    context.commit(SET_ACL, []);
    context.commit(SET_ANONYMOUS_VISIT, true);
  },
};

const mutations = {
  [SET_ACL](_state, newValue) {
    // eslint-disable-next-line no-param-reassign
    _state.acl = newValue;
  },
  [SET_ANONYMOUS_VISIT](_state, newValue) {
    // eslint-disable-next-line no-param-reassign
    _state.anonymousVisit = newValue;
  },
  [SET_USER_DATA](_state, userData) {
    // eslint-disable-next-line no-param-reassign
    _state.userData = userData;
    if (userData && userData.roles != undefined) {
      _state.userRoles = userData.roles;
    }
  },
  [SET_USER_MENU](_state, menuHtml) {
    // eslint-disable-next-line no-param-reassign
    _state.userMenu = menuHtml;
  },
  [SET_USER_ROLES](_state, userRoles) {
    // eslint-disable-next-line no-param-reassign
    _state.userRoles = userRoles;
  },
  [SET_USER_AVATAR](_state, avatarData) {
    // eslint-disable-next-line no-param-reassign
    _state.userAvatar = avatarData;
  },
  [SET_CURRENT_SUBSCRIPTION](_state, SubscriptionObject) {
    // eslint-disable-next-line no-param-reassign
    _state.currentSubscription = SubscriptionObject;
  },
  [SET_WAITING_SUBSCRIPTION](_state, SubscriptionObject) {
    // eslint-disable-next-line no-param-reassign
    _state.waitingSubscription = SubscriptionObject;
  },
  [SET_COOKIE_CONSENT_CATEGORIES](_state, categories) {
    // eslint-disable-next-line no-param-reassign
    _state.cookieConsentCategories = categories;
  },
  [SET_MAILBOX_CHANGE_INCREMENT](_state, newValue) {
    // eslint-disable-next-line no-param-reassign
    _state.mailboxChangeIncrement = newValue;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
